import {AdobeRecord, IAdobeTrackAction, IAdobeTrackState} from "modules/types/analytics";
import {AdobeTrackStateActions} from "modules/enums";
import {DateTime} from "luxon";
import {first} from "lodash";

export abstract class AdobeAnalyticService {
	private static trackedActions: string[] = [];
	private static pageType = "by the numbers";
	private static pageName = "mlb play : by the numbers : --name--";
	private static actionName = "mlb play : by the numbers : --name--";

	public static TrackAction(data: IAdobeTrackAction, addToTracked = false) {
		const params: IAdobeTrackAction = {
			...data,
			"action.name": this.actionName.replace("--name--", data["action.name"]),
		};

		window._satellite?.track(
			"trackState",
			this.stringifyParams(params as unknown as AdobeRecord)
		);
		if (addToTracked) {
			this.trackedActions.push(data["action.name"]);
		}
	}

	public static TrackState(data: IAdobeTrackState, trackOnce = false): void {
		try {
			if (trackOnce && this.GetIsActionHasBeeTracked(data["page.name"])) {
				return;
			}

			const params: IAdobeTrackState = {
				...data,
				"page.name": this.pageName.replace("--name--", data["page.name"]),
				"page.subType": data["page.subType"] || data["page.name"],
				"page.type": this.pageType,
			};

			const pageName = params["page.name"] || ("" as string);
			window.history.pushState(params, pageName);

			const fakeURL = pageName
				.split(":")
				.slice(2)
				.map((it) => {
					return it.trim().split(" ").join("_");
				})
				.join("/");

			window.dataLayer.push({
				event: "virtualPageview",
				pageUrl: fakeURL,
				pageTitle: pageName,
			});

			window._satellite?.track(
				"trackState",
				this.stringifyParams(params as unknown as AdobeRecord)
			);

			if (trackOnce) {
				this.trackedActions.push(data["page.name"]);
			}
		} catch (e) {
			console.log(e);
		}
	}

	public static GetIsActionHasBeeTracked(action: AdobeTrackStateActions | string): boolean {
		return this.trackedActions.includes(action);
	}

	public static getTodayDateForAnalytics(): string {
		return DateTime.now().toFormat("yyyy-MM-dd");
	}

	public static getRSIDFromUrlAndMoveToCookies(location: string) {
		const searchParams = new URLSearchParams(location);

		const MCID = first(
			searchParams
				.get("adobe_mc")
				?.split("|")
				.filter((e) => e.includes("MCMID"))
		);
		const PMCID = (MCID ?? "").replace("MCMID=", "");

		const MID = searchParams.get("MID");
		const rsid = searchParams.get("rsid");
		if (rsid) {
			window._satellite?.cookie.set("rsid", rsid);
		}

		if (PMCID || MID) {
			window._satellite?.cookie.set("MID", PMCID || MID!);
		}
	}

	public static appendParamsToLink(location: string) {
		try {
			const url = new URL(window._satellite.getVisitorId().appendVisitorIDsTo(location));
			const rSid = window._satellite?.cookie.get("rsid") || "none";

			url.searchParams.append("rsid", rSid);

			return url.toString();
		} catch (e) {
			console.log(e);
		}

		return location;
	}

	private static stringifyParams(params: AdobeRecord) {
		this.debugAnalytics(params);
		const prepared = {...params};
		Object.keys(prepared).forEach((key) => {
			prepared[key] = String(prepared[key]);
		});
		return prepared as Record<string, string>;
	}

	private static debugAnalytics(data: AdobeRecord): boolean {
		if (window.location.search.includes("debugAnalytics=true")) {
			console.log(data);
			return true;
		}
		return false;
	}
}
